import { WebApp } from "@/shared/telegram"

import { parseChatId } from "./parse-start-params"

const SELECTED_CHAT_KEY = "selected_chat_id"
const CLOUD_STORAGE_TIMEOUT_MS = 1500

export type StorageResult =
  | { status: "success"; value: number }
  | { status: "empty" }
  | { status: "error"; error: string }

export const getStoredChatId = (): Promise<StorageResult> => {
  return new Promise(resolve => {
    let settled = false
    const timeoutId = window.setTimeout(() => {
      if (settled) {
        return
      }
      settled = true
      resolve({ status: "error", error: "CloudStorage getItem timed out" })
    }, CLOUD_STORAGE_TIMEOUT_MS)

    try {
      WebApp.CloudStorage.getItem(SELECTED_CHAT_KEY, (error, value) => {
        if (settled) {
          return
        }
        settled = true
        window.clearTimeout(timeoutId)

        if (error) {
          resolve({ status: "error", error })
          return
        }

        if (!value) {
          resolve({ status: "empty" })
          return
        }

        const parsed = parseChatId(value)
        if (parsed !== null) {
          resolve({ status: "success", value: parsed })
        } else {
          resolve({ status: "empty" })
        }
      })
    } catch (error: unknown) {
      if (settled) {
        return
      }
      settled = true
      window.clearTimeout(timeoutId)
      const message = error instanceof Error ? error.message : "CloudStorage getItem threw"
      resolve({ status: "error", error: message })
    }
  })
}

export const setStoredChatId = (chatId: number): Promise<void> => {
  return new Promise((resolve, reject) => {
    WebApp.CloudStorage.setItem(SELECTED_CHAT_KEY, chatId.toString(), (error, success) => {
      if (error) {
        reject(new Error(error))
        return
      }
      if (success) {
        resolve()
      } else {
        reject(new Error("Failed to save chatId to cloud storage"))
      }
    })
  })
}
